import React, { useCallback } from 'react'
import { getChosenPassTier, getFormValues, getValidationSchema, setFormValues } from 'redux/slices/passTier'
import { submitPassTierSelection } from 'redux/slices/passTier/thunks'

import { AnyObject } from 'data/Common'
import Button from 'components/common/Button/Button'
import { Form } from 'data/Form'
import { PassTierItem } from 'components/set/PassTierItem/PassTierItem'
import { PaywallContainer } from 'components/common/PaywallContainer/PaywallContainer'
import { getShowPassTiers, getExplicitContentFlag, isPaywallDisabled } from 'redux/slices/liveShow'
import { isNil } from 'lodash'
import { useDispatch } from 'react-redux'
import { useForm } from 'hooks/use-form'
import { useSelector } from 'react-redux'
import { useStyles } from './styles'
import { isPopulatedArray } from 'utils/populated'
import { isFreeTier } from 'utils/passTier'
import { PaywallDisplay } from 'redux/slices/paywall'

export const ChoosePassTier: React.FC = () => {
    const classes = useStyles()
    const dispatch = useDispatch()

    const passTiers = useSelector(getShowPassTiers)
    const selectedPassTier = useSelector(getChosenPassTier)
    const initialValues = useSelector(getFormValues)
    const validationSchema = useSelector(getValidationSchema)
    const explicitContent = useSelector(getExplicitContentFlag)
    const prevState = useSelector(isPaywallDisabled) ? PaywallDisplay.REDEEM_ONLY : PaywallDisplay.PROMPT

    const onSubmit = useCallback(
        (data: AnyObject) => {
            dispatch(submitPassTierSelection(selectedPassTier!, data))
        },
        [dispatch, selectedPassTier],
    )

    const form: Form = useForm(`passTier-${selectedPassTier?._id}`, initialValues, onSubmit, validationSchema)

    const saveFormValues = useCallback(() => {
        dispatch(setFormValues(form.values))
    }, [form, dispatch])

    return (
        <PaywallContainer goBackStep={prevState} onGoBack={saveFormValues}>
            <h2 className={classes.title}>SELECT TICKET TYPE</h2>
            {explicitContent && <p className={classes.disclaimer}>** This event contains explicit content **</p>}
            <form noValidate onSubmit={form.handleSubmit} className={classes.form}>
                <ul className={classes.list}>
                    {isPopulatedArray(passTiers) &&
                        passTiers.map((passTier, index) => (
                            <PassTierItem
                                passTier={passTier}
                                index={index}
                                isExpanded={!passTier.isSoldOut && passTier._id === selectedPassTier?._id}
                                key={passTier._id}
                                form={form}
                            />
                        ))}
                </ul>
                <Button
                    type="submit"
                    disabled={isNil(selectedPassTier) || (selectedPassTier && selectedPassTier.isSoldOut)}
                    maskType="secondary"
                    fullWidth
                    id="paywall-cont-to-payment-btn"
                >
                    {selectedPassTier && isFreeTier(selectedPassTier) ? `register` : `continue to payment`}
                </Button>
            </form>
        </PaywallContainer>
    )
}

export default React.memo(ChoosePassTier)
